import React,{ Component, useState, useRef,useEffect } from "react"
import Grid from '@material-ui/core/Grid';
import { useProject } from "../Providers"
import style from "../common/setting.module.scss"
import { useForkRef } from "@material-ui/core";
import { useHistory  } from "react-router-dom";
import Radio from "@mui/material/Radio";
import { InvertColorsOff, RestaurantMenu } from "@material-ui/icons";
import axios from "axios"
import IconButton from '@mui/material/IconButton';
import ClearSharpIcon from '@mui/icons-material/ClearSharp';


export default function LedSend() {
    let history = useHistory();
    const { setting, setSetting } = useProject()
    useEffect(() => {
        //getport();
        //OpenReadComPort();
    }, []);

	const [rows, setRows] = useState([]);
    const [form, setForm] = useState({
        business:"",
        resion:"",
        company:"",
		name:"",
		password:"",
		password_confirmation: "",
    })
	const [msg, setMsg] = useState("") 
	const [msg2, setMsg2] = useState("") 
	const [Businesss, setBusinesss] = useState([])
	const [Resions, setResions] = useState([])
    const [checkedResions, setCheckedResions] = useState([]);
	const [Companys, setCompanys] = useState([])
    const [checkedCompanys, setCheckedCompanys] = useState([]);

	const [users, setUsers] = useState([])
	const [userAuth, setUserAuth] = useState([])

	const groupdata = useRef([])

     const changeHandler = (e) =>{
		if (e.currentTarget.checked) {
			setCheckedResions([...checkedResions, e.target.id]);
		} else {
			setCheckedResions(checkedResions.filter((el) => el !== e.target.id));
		}
	};

	const changeHandlerCom = (e) =>{
		if (e.currentTarget.checked) {
			setCheckedCompanys([...checkedCompanys, e.target.id]);
		} else {
			setCheckedCompanys(checkedCompanys.filter((el) => el !== e.target.id));
		}
	};


	useEffect(() => {
		async function getTotalPage() {
			await getcompanylist();
			await getuserlist();
			// setTimeout(() => setForm({
			// 	...form,
			// 	name: '',
			// 	password:'',
			// 	password_confirmation:''}), 1000);
		}
		getTotalPage();

	}, []);	

    const handleChange = (e) =>{
        setForm({
			...form,
			[e.target.name]: e.target.value.trim(),
		})
	}

	const getuserlist = async () => {
		try {
			const resp = await axios.get(
			`${process.env.REACT_APP_PUBLIC_API_URL}/users/profile`
			);
			if(resp.data.data){
				setUsers(resp.data.data);
			}
			else{
			}
		}catch (err) {
			alert(err);
		}
	};	

	const rqUserAuth = async (user) => {
		setForm({
			...form,
			name:user.username,
			password:'',
			password_confirmation:'',
		})
		setMsg2('');
		try {
			const resp = await axios.get( `${process.env.REACT_APP_PUBLIC_API_URL}/userauth`,{
				params: {
					username:user.username,
				},
			});
			if(resp.data.data) setUserAuth(resp.data.data);
			else{
				setUserAuth([]);
			}
		}catch (err) {
			alert(err);
		}
	};	

	const AddUserAuth = async (event, value) => {
		event.preventDefault();
		if(form.name =='' ) {
			setMsg2("Input Password");
			return;
		}
		if(!userAuth || userAuth.length == 0){
			setMsg2("Set User Authority");
		 	return;
		}

		const token = localStorage.getItem('accessToken');
		if (token === null) {
			alert('try login!');
			window.location.reload();
		}

		try {
		  	const resp = await axios.post(`${process.env.REACT_APP_PUBLIC_API_URL}/userauth`,
			{
				username:form.name,
				userAuth:userAuth,
			},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			if (resp.data.ok) {
				setMsg2('Save User Authority');
				await getuserlist();
			} else {
				setForm({
					...form,
					msg: resp.data.message
				})
				await getuserlist();
			}

			//switchForm(!isSignIn)
		} catch (err) {
			alert(err.message);
		}	
	}

	const handleAddUser = async (event, value) => {
		event.preventDefault();
		// for (const key in form) if (key != 'msg' && key != 'role' && (!form[key] || form[key].length === 0)){
		// 	return;
		// } 
		if(form.name =='' || form.password == '') {
			setMsg2("Input Password");
			return;
		}
		if(form.password_confirmation != form.password){
			setMsg2("Input Password");
		 	return;
		}
		try {
		  	const resp = await axios.post(`${process.env.REACT_APP_PUBLIC_API_URL}/users/signup`,
			{
				username : form.name,
				password : form.password,
				email : '',//form.email,
				telno: '',//form.telno,
				company:'',//form.company,
				role : 'ADMIN',//form.role,
			});

			if (resp.data.ok) {
				setMsg2('User Registerd..');
				await getuserlist();
			} else {
				setForm({
					...form,
					msg: resp.data.message
				})
				await getuserlist();
			}

			//switchForm(!isSignIn)
		} catch (err) {
			alert(err.message);
		}	
	}


	const renderFeedbackMessage = () =>{
		if (form.password_confirmation) {
			if (form.password_confirmation != form.password) {
			return (
   		      <label className={style.label} style={{ color:"#C3602C", marginTop:"4px"}} >Password is different!</label>
			);
		  }
		}
	}

	const handleDelUser = async (event, value) => {
		event.preventDefault();

		if (
			form.name==undefined || form.name === ""
		){
			setMsg2('Input ID..');
			return
		}

		const token = localStorage.getItem('accessToken');
		if (token === null) {
			alert('try login!');
			window.location.reload();
		}
		try {
			const resp = await axios.delete(`${process.env.REACT_APP_PUBLIC_API_URL}/users`,{
				data : {
					username : form.name,
				},
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			if (resp.data.ok) {

				const resp = await axios.delete(`${process.env.REACT_APP_PUBLIC_API_URL}/userauth`,{
					data : {
						username : form.name,
					},
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});

				setForm({
					...form,
					name: "",
					email: "",
					telno: "",
					company:"",
					password: "",
					password_confirmation: "",
					role:0,
					msg: "Deleted.."
				})
				await getuserlist();
			} else {
				setMsg2(resp.data.message);
			}
		} catch (err) {
			setMsg2('Retry login..');
		}
	};

	const selectcompany = (bus, res) => {
		var companys = [];
		var resions = [];
		groupdata.current.map(gr=>{
			if(bus == gr.group){
				if(resions.filter((el) => el == gr.resion).length==0){
					if(gr.resion != "") resions.push(gr.resion);
				}
			}
			if(bus == gr.group && res == gr.resion){
				if(companys.filter((el) => el == gr.company).length==0){
					if(gr.company != "") companys.push(gr.company);
				}
			}
		});

		if(bus != "")	setResions(resions);
		setCompanys(companys);
	}

	const getcompanylist = async () => {
		try {
			var as= `${process.env.REACT_APP_PUBLIC_API_URL}/company`;
			const resp = await axios.get( `${process.env.REACT_APP_PUBLIC_API_URL}/company`	);
			if(resp.data.data){
				//setRows(resp.data.data);
				let busis=[];
				let resis=[];
				let comps=[];
				groupdata.current = []
				resp.data.data.map(data=>{
					if( data.group != '' && busis.filter((el) => el == data.group).length==0){
						busis.push(data.group)
					}
					// if( data.resion != '' && resis.filter((el) => el == data.resion).length==0){
					// 	resis.push(data.resion)
					// }
					// if( data.company != '' && comps.filter((el) => el == data.company).length==0){
					// 	comps.push(data.company)
					// }

					groupdata.current.push(data);
				});
				
				setBusinesss(busis)
				// setResions(resis)
				// setCheckedResions(resis);
				// setCompanys(comps)
				// setCheckedCompanys(comps);

				if(form.business == "" && busis.length>0){
					setForm({
						...form,
						business: busis[0],
						resion: (resis.length>0)? resis[0]:"",
						company: "",
						name: '',
						password:'',
						password_confirmation:'',

					})
					selectcompany(busis[0], resis[0]);
				}
				else{
					selectcompany(form.business, form.resion);
				}

				// resp.data.data.reduce( (carry,el)=>{
				// 	var resion = el['resion']
				// 	if(resion && resion !=''){
				// 		setRresions([...resions, resion])
				// 		setCheckedResions([...checkedResions, resion]);
				// 	}
				// });
			}
			else{
				setMsg(resp.data.message);
			}
		}catch (err) {
			alert(err);
		}
	};	

    const addBusiness = async (event, value) => {
		event.preventDefault();

		if ((value == "business" && form.business == "" ) || (value == "resion" && form.resion == "" ) ||
			(value == "company" && form.company == "" ))return

		if(form.business == ''){
			setMsg('Select Business');
			return;
		}
		if(form.business == '' && form.company != ''){
			setMsg('Select Region');
			return;
		}

		try {
			const token = localStorage.getItem('accessToken');
			if (token === null) {
				alert('로그인 해주세요!');
				//router.push('/');
				return;
			}
		  	const resp = await axios.post(`${process.env.REACT_APP_PUBLIC_API_URL}/company`,
			{
				group : form.business,
				resion : form.resion,
				company : form.company,
			},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			if (resp.data.ok) {
				setMsg('Registered ..')
				getcompanylist();
			} else {
				setMsg(resp.data.message)
			}

			//switchForm(!isSignIn)
		} catch (err) {
			alert(err.message);
		}	
	}

	const delBusiness = async (event, value) => {
		event.preventDefault();

		if ((value == "business" && form.business == "" ) || (value == "resion" && form.resion == "" ) ||
			(value == "company" && form.company == "" ))return

		const token = localStorage.getItem('accessToken');
		if (token === null) {
			alert('로그인 해주세요!');
			return;
		}
		try {
			let resp = null;
			if(value == "business"){
				resp = await axios.delete(`${process.env.REACT_APP_PUBLIC_API_URL}/company`,{
					data : {
						group : form.business,
					},
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
			}
			else if(value == "resion"){
				resp = await axios.delete(`${process.env.REACT_APP_PUBLIC_API_URL}/company`,{
					data : {
						group : form.business,
						resion : form.resion,
					},
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
			}
			else if(value == "company"){
				resp = await axios.delete(`${process.env.REACT_APP_PUBLIC_API_URL}/company`,{
					data : {
						group : form.business,
						resion : form.resion,
						company : form.company,
					},
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
			}
			if (resp && resp.data.ok) {
				setMsg(`${form.business} deleted ..`)
				getcompanylist();
			} else if (resp){
				setMsg(resp.data.message);
			}

		} catch (err) {
			alert(err);
		}
	};

	const getUserAuth=(row, gb)=>{
		if(form.name=='') return;

		if(gb=='business'){
			setUserAuth([{
				username:form.name,
				group : row,
				resion : '',
				company : ''}]);
		}
		else if(gb=='resion'){
			if(form.business=='') return;
			var maps = []
			userAuth.map((auth)=>{
				if(auth.resion != '' && auth.company ==''){
					maps.push(auth);
				}
			})
			var inspec = userAuth.filter((el)=>(el.resion ==row && el.company ==''))
			if(!inspec || inspec.length == 0 ){
				maps.push({
					username:form.name,
					group : form.business,
					resion : row,
					company : ''});
				setUserAuth(maps);
			}
		}
		else if(gb=='company'){
			if(form.business=='' || form.resion=='') return;

			var maps = []
			userAuth.map((auth)=>{
				if(auth.company != ''){
					maps.push(auth);
				}
			})
			var inspec = userAuth.filter((el)=>(el.company ==row))
			if(!inspec || inspec.length == 0 ){
				maps.push({
					username:form.name,
					group : form.business,
					resion : form.resion,
					company : row});
				setUserAuth(maps);
			}
		}
    }

	const SelectGroup=(row, gb)=>{

		if(gb=='user'){
			setForm({
				...form,
				name:row.username,
			})
			//selectcompany(row, "");	
			return;
		}

		getUserAuth(row, gb);

		if(gb=='business'){
			setForm({
				...form,
				business:row,
			})
			selectcompany(row, "");	
		}
		else if(gb=='resion'){
			setForm({
				...form,
				resion:row,
				company:"",
			})
			selectcompany(form.business, row);	
		}
		else{
			setForm({
				...form,
				company:row,
			})
		}
	}

	function BusinessRow({key, row, gb}) {
		return (
			<div key={key} style={{marginLeft:'10px'}}>
                <button class={style.button2} onClick={()=>SelectGroup(row,gb)} >{row}</button>
			</div>		
		); 
	};	

	function UserRow({key, user}) {
		return (
			<div key={key} style={{marginLeft:'10px'}}>
                <button class={style.button2} onClick={()=>rqUserAuth(user)} >{user.username}</button>
			</div>		
		); 
	};	

	function deleteAuth(auth) {
		var res = userAuth.filter((el) => (el != auth))
		setUserAuth(res);
	};	

	function UserAuthRow({key, auth}) {
		return (
			<div key={key} style={{width:'310px'}}>
                <IconButton style={{marginRight:'20px',width:'22px',height:'22px',marginTop:'-5px', color:'#fff'}}
                    onClick={() => deleteAuth(auth)}>
                    <ClearSharpIcon />
                </IconButton>
                <span style={{marginRight:'5px'}}>{auth.group.padEnd(7,'\u0000')}</span>
                <span style={{marginRight:'30px'}}>{auth.resion.padEnd(5,'\u0000')}</span>
                <span>{auth.company}</span>
			</div>		
		); 
	};	

	function ResionRow({key, row}) {
		return (
			<div key={key} style={{width:'310px'}}>
				<input className={style.input}
				 style={{marginRight:'-30px',marginLeft:'-30px'}}
                    id={row} type="checkbox"
					onChange={changeHandler}
					checked={checkedResions.includes(row) ? true : false}/>
                <span>{row}</span>
			</div>		    
		); 
	};	

	function CompanyRow({key, row}) {
		return (
			<div key={key} style={{width:'310px'}}>
				<input className={style.input}
				 style={{marginRight:'-30px',marginLeft:'-30px'}}
                    id={row} type="checkbox"
					onChange={changeHandler}
					checked={checkedCompanys.includes(row) ? true : false}/>
                <span>{row}</span>
			</div>		    
		); 
	};	

    return (
        <div className = {style.defaultModal} style={{ display: 'flex', flexDirection:'row',marginLeft:'10px', marginTop: '50px'}}>
        <div style={{  flex: '50%'}}>
        <span className={style.nocs} style={{ marginLeft:'5px'}}> &nbsp; Register Group  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <div style={{ display: 'flex', flexDirection:'row',marginLeft:'10px', marginTop: '10px', height:'400px'}}>
        <div style={{  flex: '33%'}}>
            <span className={style.linecs} style={{ marginLeft:'5px'}}>Business &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <div style={{marginBottom:'10px'}}>
            <button className={style.button} style={{width:'65px'}} onClick={(event)=>addBusiness(event,"business")}>Add</button>
            <button className={style.button} style={{width:'65px'}} onClick={(event)=>delBusiness(event,"business")}>Delete</button>
            </div>
            <input
			className={style.input}
						style={{ width: '100px', marginLeft:'0px'}}
						type='text'
						name='business'
						placeholder='business'
						maxLength='16'
						value={form.business}
						onChange={handleChange}
						spellCheck="false"
			/>
            <div className= {style.wrapper2} style={{height:'400px',width:'160px'}}> 
                    {Businesss && Businesss.length > 0 && Businesss.map((row, i) => (
							<BusinessRow key={i} row={row} gb='business' />
					))}
            </div>
			<label className={style.label} style={{ color:"#C3602C", marginTop:"10px"}} value={msg}>{msg}</label>
        </div>
        <div style={{  flex: '33%', marginLeft:'20px'}}>	
            <span className = {style.linecs}>Region &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <div style={{marginBottom:'10px'}}>
            <button className={style.button} style={{width:'65px'}} onClick={(event)=>addBusiness(event,"resion")}>Add</button>
            <button className={style.button} style={{width:'65px'}} onClick={(event)=>delBusiness(event,"resion")}>Delete</button>
            </div>
            <input
			className={style.input}
						style={{ width: '100px', marginLeft:'0px'}}
						type='text'
						name='resion'
						placeholder='region'
						maxLength='16'
						value={form.resion}
						onChange={handleChange}
						spellCheck="false"
			/>
            <div className= {style.wrapper2} style={{height:'400px',width:'160px'}}>
				{Resions && Resions.length > 0 && Resions.map((row, i) => (
					<BusinessRow key={i+100} row={row} gb='resion' />
				))}
            </div>
        </div>
		<div style={{  flex:'33%', marginLeft:'20px'}}>	
            <span className = {style.linecs}>Company &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <div style={{marginBottom:'10px'}}>
            <button className={style.button} style={{width:'65px'}} onClick={(event)=>addBusiness(event,"company")}>Add</button>
            <button className={style.button} style={{width:'65px'}} onClick={(event)=>delBusiness(event,"company")}>Delete</button>
            </div>
            <input
			className={style.input}
						style={{ width: '100px', marginLeft:'0px'}}
						type='text'
						name='company'
						placeholder='company'
						maxLength='16'
						value={form.company}
						onChange={handleChange}
						spellCheck="false"
			/>
                <div className= {style.wrapper2} style={{height:'400px',width:'160px'}}>
					{Companys && Companys.length > 0 && Companys.map((row, i) => (
						<BusinessRow key={i+200} row={row} gb='company'/>
					))}
                </div>
	        </div>
        </div>
        </div>
        <div style={{  flex: '50%'}}>
		<span className = {style.nocs}>Register User</span>
		<div style={{ display: 'flex', flexDirection:'row',marginLeft:'10px', marginTop: '10px', height:'400px'}}>
		<div style={{  flex:'30%', marginLeft:'10px'}}>	
			<span className = {style.linecs}>User list &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
				<div>
				<div style={{marginBottom:'10px'}}>
            		<button className={style.button} style={{width:'65px'}} onClick={handleAddUser}>Add</button>
            		<button className={style.button} style={{width:'65px'}} onClick={handleDelUser}>Delete</button>
            	</div>					
				<label className={style.label} style={{marginLeft:'-15px'}}>ID : </label>
				<input
				className={style.input}
						style={{ width: '100px', marginLeft:'-10px'}}
						type='text'
						name='name'
						placeholder='ID'
						maxLength='16'
						value={form.name}
						onChange={handleChange}
						spellCheck="false"
				/>
				</div>
			<div className= {style.wrapper2} style={{height:'400px',width:'180px', marginTop:'5px'}}>
				{users && users.length > 0 && users.map((user, i) => (
					<UserRow key={i+300} user={user} />
				))}
			</div>
		</div>
		<div style={{  flex:'70%', marginLeft:'24px'}}>	
			<br></br>
			<div style={{marginTop:'20px'}}>
				<br></br>
				<label className={style.label} style={{marginLeft:'-15px'}} >PW : </label>
				<input
				className={style.input}
						style={{ width: '100px', marginLeft:'-10px'}}
						type='password'
						name='password'
						placeholder='PW'
						maxLength='16'
						value={form.password}
						onChange={handleChange}
						spellCheck="false"
				/>
				<label className={style.label} style={{marginLeft:'-10px'}} >PW2 : </label>
				<input
				className={style.input}
						style={{ width: '100px', marginLeft:'-13px'}}
						type='password'
						name='password_confirmation'
						placeholder='PW Confirm'
						maxLength='16'
						value={form.password_confirmation}
						onChange={handleChange}
						spellCheck="false"
				/>
			</div>
			<span className = {style.linecs}>Authorize &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
			<button className={style.button} style={{width:'65px', marginLeft:'20px'}} onClick={AddUserAuth}>Add</button>
			<div className= {style.wrapper2} style={{height:'355px',width:'350px', marginTop:'10px'}}>
					<span style={{color:'#C3602C',fontWeight:'600'}}>Del &nbsp;&nbsp;Business &nbsp;&nbsp;&nbsp; Region &nbsp;&nbsp;&nbsp;&nbsp; Company</span>
					{userAuth && userAuth.length > 0 && userAuth.map((row, i) => (
						<UserAuthRow key={i} auth={row} />
					))}
            </div>
			{/* {renderFeedbackMessage()} */}
			<label className={style.label} style={{ color:"#C3602C", marginTop:"10px"}} value={msg2}>{msg2}</label>
		</div>
	    </div>
        </div>
        </div>
    );

}
